import React, { useState } from "react";
import {
  Bar,
  Icon,
  IconsWrapper,
  Logo,
  LogoWrapper,
  ReloadIcon,
  Wallet,
  WalletText,
  WalletTop,
  WalletTopAdd,
} from "./Appbar.style";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE, PRIVATE_ROUTE } from "@router/route.constants";
import {
  DownloadOutlined,
  MessageOutlined,
  TopWalletFilled,
  TopWalletAddFilled,
  BalanceLoading,
} from "@assets";
import { setOpenLoginAlert, saveUser } from "@redux/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import Lottie from "react-lottie";
import { getFormattedNumber, localStorage } from "@utils";
import { api } from '@api';

const Appbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.token);
  const { main_balance, bonus, is_in_game, can_exit_check } = useSelector(
    (state) => state.auth.user
  );
  const [loading, setLoading] = useState(false);

  const goToWallet = () => {
    if (!checkIsLoggedIn()) {
      return;
    }
    navigate(`/${PRIVATE_ROUTE.WALLET}`);
  };

  const checkIsLoggedIn = () => {
    if (!isLoggedIn) {
      dispatch(setOpenLoginAlert(true));
    }
    return isLoggedIn;
  };

  const goToDownload = () => {
    navigate(`/${PUBLIC_ROUTE.APP_DOWNLOAD}`);
  };

  const goToMessages = () => {
    navigate(`/${PUBLIC_ROUTE.MESSAGE}`);
  };

  const checkExit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!loading) {
      setLoading(true);
      api
        .checkExit()
        .then(({ user }) => {
          // save user to redux
          dispatch(saveUser(user));
          // save user to localstorage
          localStorage.setUser(user);
        })
        .catch(() => { });
    }
  }

  return (
    <Bar>
      <LogoWrapper>
        <Logo />
      </LogoWrapper>
      <IconsWrapper>
        <Wallet onClick={goToWallet}>
          <WalletTop>
            <TopWalletFilled />
          </WalletTop>
          <WalletText>
            {is_in_game ? (
              <Lottie
                options={{
                  animationData: BalanceLoading,
                }}
                width={32}
                height={32}
              />
            ) : (
              `${getFormattedNumber(main_balance + bonus)} Ks`
            )}
          </WalletText>
          <WalletTopAdd>
            {can_exit_check ? <ReloadIcon onClick={checkExit} /> : <TopWalletAddFilled />}
          </WalletTopAdd>
        </Wallet>

        <Icon onClick={goToMessages}>
          <MessageOutlined />
        </Icon>

        <DownloadOutlined onClick={goToDownload} />
      </IconsWrapper>
    </Bar>
  );
};

export default Appbar;
